export default __webpack_public_path__ + "static/media/640_business01-fr-web.affd3d78.png";